import { css } from 'styled-components';

export const media = {
  small: (...args) => css`
    @media (min-width: 30em) {
      ${css(...args)};
    }
  `,

  medium: (...args) => css`
    @media (min-width: 45em) {
      ${css(...args)};
    }
  `,

  mediumLarge: (...args) => css`
    @media (min-width: 48em) {
      ${css(...args)};
    }
  `,
  large: (...args) => css`
    @media (min-width: 64.0625em) {
      ${css(...args)};
    }
  `,
  extraLarge: (...args) => css`
    @media (min-width: 75em) {
      ${css(...args)};
    }
  `,
};



// WEBPACK FOOTER //
// /tmp/build_2cb81483/src/styles/style-utils.js